"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetApprovalsProvider = void 0;
require("./asset-approvals-provider.less");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const review_asset_1 = require("../../components/review-asset");
const router_1 = require("client/components/router");
const material_ui_1 = require("material-ui");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("../../store");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_3 = require("client/modules/users/store");
// import { Component } from "react";
const columns = [
    {
        id: "upload.fileOriginalName",
        label: "Asset Name"
    },
    {
        id: "provider.lastName",
        label: "Provider Name"
    },
    {
        id: "provider.id",
        label: "Entity"
    }
];
let AssetApprovalsProvider = class AssetApprovalsProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "upload.fileOriginalName";
        this.isCollapse = true;
        this.editId = -1;
        this.autoFocusForm = true;
        this.currentRowIndex = -1;
        this.routeId = -1;
        this.didChange = false;
        this.showRejected = false;
        this.connectAssetCategories = [];
        this.loadAssets = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                entity: "provider",
                order: this.order,
                showRejected: this.showRejected.toString(),
                sort: this.orderBy,
                start: 0
            };
            await store_2.assetApprovalsStore.loadAssets(options);
        });
        this.generateCategoryNames = async () => {
            const categories = await store_1.appSettingsStore.readConnectAsset("provider");
            if (categories) {
                const cleaned = categories
                    .filter((category) => category.deletedAt === null)
                    .sort((a, b) => a.categoryName > b.categoryName ? 1 : -1)
                    .map((e) => e);
                this.connectAssetCategories.push({
                    id: 0,
                    label: "--",
                    value: "0"
                });
                cleaned.forEach((category, i) => this.connectAssetCategories.push({
                    id: i + 1,
                    label: category.categoryName,
                    value: `${category.id}`
                }));
            }
            else {
                this.connectAssetCategories = [];
            }
        };
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                this.isCollapse = false;
            }
            this.editId = row.id;
            this.currentRowIndex = index;
            router_1.RouteManager.transitionTo(`/assetapprovals/${row.id}`);
        };
        this.onHandleSave = async (asset, key) => {
            const updatedAsset = await store_2.assetApprovalsStore.saveAsset(asset);
            // console.log("updated asset", updatedAsset);
            const nextAsset = key + 1;
            const nextAssetId = store_2.assetApprovalsStore.assets.value[nextAsset]
                ? store_2.assetApprovalsStore.assets.value[nextAsset].id
                : null;
            if (updatedAsset) {
                if (nextAssetId) {
                    router_1.RouteManager.transitionTo(`/assetapprovals/${nextAssetId}`);
                }
                else {
                    router_1.RouteManager.transitionTo("/assetapprovals");
                    await this.loadAssets();
                }
            }
        };
        this.onHandleReject = async (asset, key) => {
            const updatedAsset = await store_2.assetApprovalsStore.rejectAsset(asset);
            const nextAsset = key + 1;
            const nextAssetId = store_2.assetApprovalsStore.assets.value[nextAsset]
                ? store_2.assetApprovalsStore.assets.value[nextAsset].id
                : null;
            if (updatedAsset) {
                if (nextAssetId) {
                    router_1.RouteManager.transitionTo(`/assetapprovals/${nextAssetId}`);
                }
                else {
                    await this.loadAssets();
                    router_1.RouteManager.transitionTo("/assetapprovals");
                }
            }
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: -1 }, !this.isCollapse && (this.editId === row.id || this.routeId === row.id) && (React.createElement(review_asset_1.ReviewAsset, { autoFocusForm: this.autoFocusForm, error: store_2.assetApprovalsStore.reviewAsset.error, key: index, indexkey: index, loading: store_2.assetApprovalsStore.reviewAsset.loading, onCancel: () => {
                this.editId = -1;
                router_1.RouteManager.transitionTo("/assetapprovals");
                store_2.assetApprovalsStore.reviewAsset.error = null;
            }, onSave: this.onHandleSave, onReject: this.onHandleReject, asset: row, connectAssetCategories: this.connectAssetCategories, status: store_2.assetApprovalsStore.reviewAsset.status, rejected: this.showRejected }))));
        this.renderListRow = (row, index) => {
            const providerName = row.provider.lastName && row.provider.firstName
                ? `${row.provider.lastName}, ${row.provider.firstName}`
                : `${row.provider.firstName} ${row.provider.lastName}`;
            const entity = row.informationType === "providerCredentials"
                ? "Provider Credentials"
                : "";
            return [
                React.createElement(list_item_1.MaterialListItem, { className: "", key: index, onClick: () => {
                        this.onHandleClickRow(row, index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.fileOriginalName }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(providerName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: entity })),
                this.renderListRowEditMode(row, index)
            ];
        };
        this.onRequestSort = async (property) => {
            if (this.orderBy === property) {
                if (this.order === "ASC") {
                    this.order = "DESC";
                }
                else {
                    this.order = "ASC";
                }
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            await this.loadAssets();
        };
        this.handleToggle = async () => {
            this.showRejected = !this.showRejected;
            await this.loadAssets();
        };
    }
    componentWillMount() {
        // console.log("this props params", this.props.params[0]);
        if (this.props.params) {
            this.routeId = Number(this.props.params[0]);
        }
        if (this.routeId > 0) {
            this.isCollapse = false;
        }
    }
    async componentDidMount() {
        await store_2.assetApprovalsStore.loadAssets();
        await this.generateCategoryNames();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
        if (this.props.params) {
            this.routeId = Number(this.props.params[0]);
        }
        if (this.routeId > 0 && this.editId !== this.routeId) {
            this.isCollapse = false;
            this.editId = this.routeId;
        }
        if (this.props.params && this.props.params.length === 0) {
            this.isCollapse = true;
            this.editId = -1;
        }
    }
    renderList() {
        const { assets: { value: assets = [] } } = store_2.assetApprovalsStore;
        return (React.createElement("div", { className: "asset-approvals__data__list__info" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: assets, renderRow: this.renderListRow, withMargin: true, wideHeader: true, resizableheader: true, customClass: "custom-material-list__assets-list" })));
    }
    renderInfo() {
        return (React.createElement("div", { className: "asset-approvals__data" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Assets Pending Approval"),
            React.createElement("div", { className: "asset-approvals__data__toggle" },
                React.createElement(switch_1.MaterialSwitch, { label: "Show Rejected Assets", value: "true", checked: this.showRejected, onChange: this.handleToggle })),
            React.createElement("div", { className: "asset-approvals__data__list" }, this.renderList())));
    }
    render() {
        return (React.createElement("div", { className: "asset-approvals" }, store_3.usersStore.permissions.ReadAssetApprovals ? (React.createElement(React.Fragment, null,
            this.renderInfo(),
            React.createElement(ReactTooltip, { effect: "solid", place: "right" }))) : (store_3.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "routeId", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "didChange", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "showRejected", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsProvider.prototype, "connectAssetCategories", void 0);
AssetApprovalsProvider = __decorate([
    mobx_react_1.observer
], AssetApprovalsProvider);
exports.AssetApprovalsProvider = AssetApprovalsProvider;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/tabs/asset-approvals-provider/asset-approvals-provider.tsx
// module id = 3215
// module chunks = 0